// extracted by mini-css-extract-plugin
export default {"seo-links-container":"g__seo-links-container--FVHbD","dropdown-menu":"g__dropdown-menu--xaT3f"};